import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Verifica from "../views/Verifica.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/verifica",
    name: "Verifica",
    component: Verifica,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
